import UserCircleSVG from "@design-system/ui-icons/vanilla/UserCircle"
import { createIcon } from "../createIcon"

export const UserCircleIcon = createIcon(UserCircleSVG)
